"use client";

import type { ReactNode } from "react";

import { Button, Spinner } from "@heroui/react";

/**
 * Submit control with an in-place pending state.
 *
 * Disabled while pending so a double-tap can't fire two sign-up requests, and
 * the label is kept alongside the spinner rather than replaced — a button that
 * changes width mid-submit shifts everything around it.
 */
export function SubmitButton({
  children,
  isPending,
  variant = "primary",
}: {
  children: ReactNode;
  isPending: boolean;
  variant?: "primary" | "secondary";
}) {
  return (
    <Button
      type="submit"
      variant={variant}
      fullWidth
      isDisabled={isPending}
      className="gap-2"
    >
      {isPending ? <Spinner size="sm" color="current" /> : null}
      {children}
    </Button>
  );
}
